import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { clearBuildBundlesValues, updateBuildBundlesValues, hideBuildBundlesModal, startBundleBuild } from '../../actions';
import { BuildBundlesModal } from './BuildBundlesModal';

class BuildBundlesModalController extends Component {
    constructor(props) {
        super(props);

        this.formUpdated = this.formUpdated.bind(this);
        this.formSubmitted = this.formSubmitted.bind(this);
    } 

    formSubmitted(event) {
        event.preventDefault();
        const {data, scene, startBundleBuild} = this.props;

        startBundleBuild(data.branchName, scene);
    }

    formUpdated(event) {
        const {updateBuildBundlesValues, data} = this.props;
        const {target} = event;

        const key = _.camelCase(target.name);
        updateBuildBundlesValues({
            ...data,
            [key]: target.value,
            [`${key}Valid`]: isValid(key, target.value)
        });
    }

    render() {
        const {show, hideBuildBundlesModal, clearBuildBundlesValues, scene, data} = this.props;
        return (
            <BuildBundlesModal
                show={show}
                hide={() => {
                    clearBuildBundlesValues();
                    hideBuildBundlesModal();
                }}
                scene={scene}
                data={{
                    branchNameValid:      validationState(data.branchNameValid),
                    isRequestingBuild:    data.isRequestingBuild,
                    formValid:            formValid(data)
                }}
                updated={this.formUpdated}
                submitted={this.formSubmitted}
            />
        );
    }
}

const isValid = (name, value) => {
    switch(name) {
        case 'branchName': return !!value;              
        default:           return false;
    }
};

const validationState = isValid => {
    return isValid ? 'success' : 'error';
};

const formValid = data => {
    return data.branchNameValid;
};

BuildBundlesModalController.propTypes = {
    show:                     PropTypes.bool.isRequired,
    hideBuildBundlesModal:    PropTypes.func.isRequired,
    clearBuildBundlesValues:  PropTypes.func.isRequired,
    updateBuildBundlesValues: PropTypes.func.isRequired,
    startBundleBuild:         PropTypes.func.isRequired,
    scene:                    PropTypes.string.isRequired,
    data:                     PropTypes.object.isRequired,
};

const mapDispatchToProps = {
    updateBuildBundlesValues,
    clearBuildBundlesValues,
    hideBuildBundlesModal,
    startBundleBuild
};

const mapStateToProps = state => ({
    scene: state.scene.current,
    data: state.ui.bundleData,
    show: state.ui.buildBundles.show
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BuildBundlesModalController);



// WEBPACK FOOTER //
// ./src/components/buildBundlesModal/BuildBundlesModalController.js